export const IFC_VALUE_TYPE_TO_UNIT_ENUM: Record<string, string> = {
  IfcLengthMeasure: 'LENGTHUNIT',
  IfcPositiveLengthMeasure: 'LENGTHUNIT',
  IfcNonNegativeLengthMeasure: 'LENGTHUNIT',
  IfcQuantityLength: 'LENGTHUNIT',
  IfcAreaMeasure: 'AREAUNIT',
  IfcQuantityArea: 'AREAUNIT',
  IfcVolumeMeasure: 'VOLUMEUNIT',
  IfcQuantityVolume: 'VOLUMEUNIT',
  IfcMassMeasure: 'MASSUNIT',
  IfcQuantityWeight: 'MASSUNIT',
  IfcTimeMeasure: 'TIMEUNIT',
  IfcQuantityTime: 'TIMEUNIT',
  IfcPlaneAngleMeasure: 'PLANEANGLEUNIT',
  IfcPositivePlaneAngleMeasure: 'PLANEANGLEUNIT',
  IfcSolidAngleMeasure: 'SOLIDANGLEUNIT',
  IfcThermodynamicTemperatureMeasure: 'THERMODYNAMICTEMPERATUREUNIT',
  IfcAmountOfSubstanceMeasure: 'AMOUNTOFSUBSTANCEUNIT',
  IfcLuminousIntensityMeasure: 'LUMINOUSINTENSITYUNIT',
  IfcElectricCurrentMeasure: 'ELECTRICCURRENTUNIT',
  IfcPressureMeasure: 'PRESSUREUNIT',
  IfcForceMeasure: 'FORCEUNIT',
  IfcEnergyMeasure: 'ENERGYUNIT',
  IfcPowerMeasure: 'POWERUNIT',
  IfcFrequencyMeasure: 'FREQUENCYUNIT',
  IfcElectricVoltageMeasure: 'ELECTRICVOLTAGEUNIT',
  IfcElectricResistanceMeasure: 'ELECTRICRESISTANCEUNIT',
  IfcElectricCapacitanceMeasure: 'ELECTRICCAPACITANCEUNIT',
  IfcElectricConductanceMeasure: 'ELECTRICCONDUCTANCEUNIT',
  IfcElectricChargeMeasure: 'ELECTRICCHARGEUNIT',
  IfcMagneticFluxMeasure: 'MAGNETICFLUXUNIT',
  IfcMagneticFluxDensityMeasure: 'MAGNETICFLUXDENSITYUNIT',
  IfcInductanceMeasure: 'INDUCTANCEUNIT',
  IfcIlluminanceMeasure: 'ILLUMINANCEUNIT',
  IfcLuminousFluxMeasure: 'LUMINOUSFLUXUNIT',
  IfcRadioActivityMeasure: 'RADIOACTIVITYUNIT',
  IfcAbsorbedDoseMeasure: 'ABSORBEDDOSEUNIT',
  IfcDoseEquivalentMeasure: 'DOSEEQUIVALENTUNIT',

  IfcCompoundPlaneAngleMeasure: 'COMPOUNDPLANEANGLEUNIT',
  IfcAccelerationMeasure: 'ACCELERATIONUNIT',
  IfcAngularVelocityMeasure: 'ANGULARVELOCITYUNIT',
  IfcAreaDensityMeasure: 'AREADENSITYUNIT',
  IfcCurvatureMeasure: 'CURVATUREUNIT',
  IfcDynamicViscosityMeasure: 'DYNAMICVISCOSITYUNIT',
  IfcHeatFluxDensityMeasure: 'HEATFLUXDENSITYUNIT',
  IfcHeatingValueMeasure: 'HEATINGVALUEUNIT',
  IfcIntegerCountRateMeasure: 'INTEGERCOUNTRATEUNIT',
  IfcIonConcentrationMeasure: 'IONCONCENTRATIONUNIT',
  IfcIsothermalMoistureCapacityMeasure: 'ISOTHERMALMOISTURECAPACITYUNIT',
  IfcKinematicViscosityMeasure: 'KINEMATICVISCOSITYUNIT',
  IfcLinearForceMeasure: 'LINEARFORCEUNIT',
  IfcLinearMomentMeasure: 'LINEARMOMENTUNIT',
  IfcLinearStiffnessMeasure: 'LINEARSTIFFNESSUNIT',
  IfcLinearVelocityMeasure: 'LINEARVELOCITYUNIT',
  IfcLuminousIntensityDistributionMeasure: 'LUMINOUSINTENSITYDISTRIBUTIONUNIT',
  IfcMassDensityMeasure: 'MASSDENSITYUNIT',
  IfcMassFlowRateMeasure: 'MASSFLOWRATEUNIT',
  IfcMassPerLengthMeasure: 'MASSPERLENGTHUNIT',
  IfcModulusOfElasticityMeasure: 'MODULUSOFELASTICITYUNIT',
  IfcModulusOfLinearSubgradeReactionMeasure: 'MODULUSOFLINEARSUBGRADEREACTIONUNIT',
  IfcModulusOfRotationalSubgradeReactionMeasure: 'MODULUSOFROTATIONALSUBGRADEREACTIONUNIT',
  IfcModulusOfSubgradeReactionMeasure: 'MODULUSOFSUBGRADEREACTIONUNIT',
  IfcMoistureDiffusivityMeasure: 'MOISTUREDIFFUSIVITYUNIT',
  IfcMolecularWeightMeasure: 'MOLECULARWEIGHTUNIT',
  IfcMomentOfInertiaMeasure: 'MOMENTOFINERTIAUNIT',
  IfcPHMeasure: 'PHUNIT',
  IfcPlanarForceMeasure: 'PLANARFORCEUNIT',
  IfcRotationalFrequencyMeasure: 'ROTATIONALFREQUENCYUNIT',
  IfcRotationalMassMeasure: 'ROTATIONALMASSUNIT',
  IfcRotationalStiffnessMeasure: 'ROTATIONALSTIFFNESSUNIT',
  IfcSectionAreaIntegralMeasure: 'SECTIONAREAINTEGRALUNIT',
  IfcSectionModulusMeasure: 'SECTIONMODULUSUNIT',
  IfcShearModulusMeasure: 'SHEARMODULUSUNIT',
  IfcSoundPowerLevelMeasure: 'SOUNDPOWERLEVELUNIT',
  IfcSoundPowerMeasure: 'SOUNDPOWERUNIT',
  IfcSoundPressureLevelMeasure: 'SOUNDPRESSURELEVELUNIT',
  IfcSoundPressureMeasure: 'SOUNDPRESSUREUNIT',
  IfcSpecificHeatCapacityMeasure: 'SPECIFICHEATCAPACITYUNIT',
  IfcTemperatureGradientMeasure: 'TEMPERATUREGRADIENTUNIT',
  IfcTemperatureRateOfChangeMeasure: 'TEMPERATURERATEOFCHANGEUNIT',
  IfcThermalAdmittanceMeasure: 'THERMALADMITTANCEUNIT',
  IfcThermalConductivityMeasure: 'THERMALCONDUCTIVITYUNIT',
  IfcThermalExpansionCoefficientMeasure: 'THERMALEXPANSIONCOEFFICIENTUNIT',
  IfcThermalResistanceMeasure: 'THERMALRESISTANCEUNIT',
  IfcThermalTransmittanceMeasure: 'THERMALTRANSMITTANCEUNIT',
  IfcTorqueMeasure: 'TORQUEUNIT',
  IfcVaporPermeabilityMeasure: 'VAPORPERMEABILITYUNIT',
  IfcVolumetricFlowRateMeasure: 'VOLUMETRICFLOWRATEUNIT',
  IfcWarpingConstantMeasure: 'WARPINGCONSTANTUNIT',
  IfcWarpingMomentMeasure: 'WARPINGMOMENTUNIT',
};

export interface IfcUnit {
  name?: string | null;
  className?: string | null;
  unitEnum?: string | null;
}

export interface IfcUnitProperty {
  unit?: number | null;
  ifcValueType?: string;
}

export function resolveIfcUnitId(units: IfcUnit[], property: IfcUnitProperty): number | null {
  if (property.unit != null) return property.unit;
  if (!property.ifcValueType) return null;

  const unitEnum = IFC_VALUE_TYPE_TO_UNIT_ENUM[property.ifcValueType];
  if (!unitEnum) return null;

  // `units` is a flat, unordered list of every unit in the IFC file. Imperial models hold BOTH the
  // assigned conversion-based unit (e.g. FOOT) and the SI unit it derives from (e.g. METRE) under
  // the same unitEnum, so prefer the IfcConversionBasedUnit — the actual project unit.
  const conversionIndex = units.findIndex(
    (unit) => unit.unitEnum === unitEnum && unit.className === 'IfcConversionBasedUnit',
  );
  if (conversionIndex >= 0) return conversionIndex;

  const index = units.findIndex((unit) => unit.unitEnum === unitEnum);
  return index >= 0 ? index : null;
}
